
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Grid, GridItem, Size, Tile, Speed } from '@drawbotics/react-drylus';
import sv from '@drawbotics/drylus-style-vars';
import Playground, { PropsTable } from '~/components/Playground';
export const Component = ({
  style = {}
}) => {
  return <div style={{
    height: '50px',
    width: '100%',
    background: 'red',
    border: '1px solid orange',
    ...style
  }} />;
};

const layoutProps = {
  Component
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Grid`}</h1>
<p>{`This component is used to organise elements on the page following a classic grid layout. To not be mistaken with the `}<a parentName="p" {...{
        "href": "/layout/flex"
      }}><inlineCode parentName="a">{`Flex`}</inlineCode></a>{` component which is used to organise elements in a vertical or horizontal row.`}</p>
<p>{`Grid only acts horizontally, creating a fixed number of columns, and a variable number of rows depending on the amount of children elements.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Grid, GridItem } from '@drawbotics/react-drylus';
`}</code></pre>

<p>{`Example:`}</p>
<Playground __position={0} __code={`<Grid columns={4} hGutters={Size.DEFAULT} vGutters={Size.DEFAULT}>
  <GridItem rowSpan={2}>
    <Component style={{ height: '100%' }} />
  </GridItem>
  <GridItem span={2}>
    <Component />
  </GridItem>
  <GridItem>
    <Component />
  </GridItem>
  <GridItem>
    <Component />
  </GridItem>
  <GridItem>
    <Component />
  </GridItem>
</Grid>`} component={Grid} mdxType="Playground">
  <Grid columns={4} hGutters={Size.DEFAULT} vGutters={Size.DEFAULT} mdxType="Grid">
    <GridItem rowSpan={2} mdxType="GridItem">
      <Component style={{
            height: '100%'
          }} mdxType="Component" />
    </GridItem>
    <GridItem span={2} mdxType="GridItem">
      <Component mdxType="Component" />
    </GridItem>
    <GridItem mdxType="GridItem">
      <Component mdxType="Component" />
    </GridItem>
    <GridItem mdxType="GridItem">
      <Component mdxType="Component" />
    </GridItem>
    <GridItem mdxType="GridItem">
      <Component mdxType="Component" />
    </GridItem>
  </Grid>
</Playground>
<h3>{`Grid Item`}</h3>
<p>{`The `}<inlineCode parentName="p">{`GridItem`}</inlineCode>{` by default will take 1 column of space, and only 1 row. By changing the `}<inlineCode parentName="p">{`span`}</inlineCode>{` prop you can define how many columns it will take.`}</p>
<PropsTable component={GridItem} mdxType="PropsTable" />
<h3>{`Animated Grid example`}</h3>
<p>{`If the animation already played, click on the refresh icon on the bottom right to start it again.`}</p>
<Playground __position={2} __code={`<div style={{ background: sv.backgroundColor, margin: -24, padding: 24 }}>
  <Grid animated columns={4} hGutters={Size.SMALL} vGutters={Size.SMALL}>
    {[...Array(16).keys()].map((i) =>
      <GridItem key={i}>
        <Tile><div style={{ height: 100 }} /></Tile>
      </GridItem>
    )}
  </Grid>
</div>`} mode="jsx" mdxType="Playground">
  <div style={{
        background: sv.backgroundColor,
        margin: -24,
        padding: 24
      }}>
    <Grid animated columns={4} hGutters={Size.SMALL} vGutters={Size.SMALL} mdxType="Grid">
      {[...Array(16).keys()].map(i => <GridItem key={i} mdxType="GridItem">
          <Tile mdxType="Tile"><div style={{
                height: 100
              }} /></Tile>
        </GridItem>)}
    </Grid>
  </div>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;